import type { PlanBlocker } from './apply-types';

/**
 * 86-23: the copy key for a derived blocker. The plan sends '' when it has no
 * location or SKU to name, so those variants have their own wording and a
 * blocker never reads "at :".
 */
export function blockerMessageKey(blocker: Pick<PlanBlocker, 'reason' | 'sku' | 'locationName' | 'badValue'>): string {
  const base = `job.blocker.${blocker.reason}`;
  const hasSku = Boolean(blocker.sku);
  const hasLocation = Boolean(blocker.locationName);
  switch (blocker.reason) {
    case 'sku_in_use':
    case 'blank_not_found':
      return hasSku ? base : `${base}_noSku`;
    case 'sku_in_use_at_floor':
      if (hasSku && hasLocation) return base;
      if (hasSku) return `${base}_noLocation`;
      return hasLocation ? `${base}_noSku` : `${base}_noDetails`;
    case 'design_variant_unreadable':
      // Name the value we could not read when the plan sent it.
      return blocker.badValue ? `${base}_value` : base;
    default:
      return base;
  }
}

/** The plan's blockers, one entry per product in first-seen order (86-23 review: one
 * product can carry several blockers; the gate renders one card listing all). */
export function groupBlockersByProduct(blockers: readonly PlanBlocker[]): PlanBlocker[][] {
  const byProduct = new Map<string, PlanBlocker[]>();
  for (const blocker of blockers) {
    const group = byProduct.get(blocker.productId);
    if (group) group.push(blocker);
    else byProduct.set(blocker.productId, [blocker]);
  }
  return [...byProduct.values()];
}
